module.exports = __webpack_public_path__ + "static/gc-white-e3130089591853a97f3ea32c6dd036f2.png";